import { TableView, MailRowDataPropertyGetter } from 'owa-mail-list-store';
import { TriageContext, ActionType } from 'owa-mail-actions';

export default function getUserInteractionContext(
    rowKeys: string[],
    tableView: TableView,
    actionType: ActionType,
    folderId?: string
): TriageContext {
    if (rowKeys.length != 1) {
        return null; // scoping the behavior logging to single row operations for now
    }

    const rowKey = rowKeys[0];
    const uniqueSendersFromMailData = MailRowDataPropertyGetter.getUniqueSenders(rowKey, tableView);
    const smtpAddress = MailRowDataPropertyGetter.getLastSenderSMTP(rowKey, tableView);
    const triageContext = {
        uniqueSenders: uniqueSendersFromMailData,
        lastSenderSmtpAddress: smtpAddress,
        folderId: folderId,
    };

    return triageContext;
}
